export default "__VITE_ASSET__Ci$eVCG1__"